var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      directives: [{ name: "title", rawName: "v-title" }],
      staticClass: "flex column",
      staticStyle: { width: "100vm" },
      attrs: { "data-title": "其他问题" }
    },
    _vm._l(_vm.list, function(data, index) {
      return _c("div", { key: index }, [
        _c(
          "div",
          {
            staticClass: "flex column",
            staticStyle: { height: "49px", margin: "0 16px" },
            on: {
              click: function($event) {
                _vm.$router.push({
                  name: "QuestionDetail",
                  params: { question: JSON.stringify(data) }
                })
              }
            }
          },
          [
            _c(
              "div",
              {
                staticClass: "flex main-space-between cross-center",
                staticStyle: { height: "49px" }
              },
              [
                _c("span", [
                  _vm._v(_vm._s(index + 1) + "." + _vm._s(data.title))
                ]),
                _vm._v(" "),
                _c("img", {
                  staticStyle: { width: "7px", height: "13px" },
                  attrs: { src: require("../assets/arrow_right.png") }
                })
              ]
            ),
            _vm._v(" "),
            _c("div", {
              staticStyle: {
                background: "#EEEEEEFF",
                height: "1px",
                width: "100%"
              }
            })
          ]
        )
      ])
    }),
    0
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-29db7559", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-29db7559","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/AboutStudentCourse.vue
// module id = null
// module chunks = 